import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uiChangeProvider } from '../../../actions/ui';
import ProviderCommonApi from '../../../API/provider/common-api';
import ComplexBarApi from '../../../API/provider/complexBar-api';
import EtmApi from '../../../API/provider/etm-api';
import ProviderInfoApi from '../../../API/provider/providerInfo-api';
import StocksApi from '../../../API/provider/stocks-api';
import { Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ImportExcelButton, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { TYPE_BUTTONS } from '../../../constans';
import { divideToSubarray } from '../../../utils';

// 28 - Perfeo
// 24 - Ritmix
// 4 - Merlion
// 6 - PcShop
// 9 - Nix
// 35 - Kosmart
// 36 - KDV Яшкино
// 37 - Гала-центр
// 38 - Kristaller
// 25 - Клавторг
// 40 - 18+
// 41 - 4fresh
// 7 - rustrus
// 29 - Сладрус
// 39 - Мир красок
// 26 - гавриш
// 8 - Обезличка
// 46 - Ашанти
// 44 - Snumway
// 16 - NovaSport
// 20 - Все инстументы
// 4 - Мерлион

const MAP_STOCKS_VI = {
  '> 10': 20,
  '>20': 30,
  '> 20': 30,
  '>100': 100,
  '> 100': 20,
  'Под заказ': 0,
};

const MAP_STOCKS_AT = {
  '>20': 30,
  '> 20': 30,
  '>100': 100,
  '> 100': 20,
};

function StocksPage() {
  const dispatch = useDispatch();
  const [provider, changeProvider] = useState({});
  const [providers, setProviders] = useState([]);
  const allProviders = useSelector((store) => store.providers);
  const selectProvider = useSelector((store) => store.ui.selectProvider);
  const user = useSelector((store) => store.user);

  const formProviderDataStocks = async (providerId, data, skladName) => {
    console.log(providerId, data);
    // perfeo
    if (providerId === 28) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул '] || item['Артикул'] || item['Номенклатура.Артикул'] || '',
          brand: '',
          name: item['Номенклатура'] || item['Номенклатура/ Характеристика номенклатуры'],
          quantity: item['Кол-во в упаковке'],
          category: item['Категория'],
          cost: item['VIP'] || item['руб'] || item['РУБ'] || item['Руб'],
          availability: item['Остаток'],
          course: provider.course,
          min_opt: 1,
        }))
        .filter((item) => item.sku !== '');

      trueData = trueData.map((item) => ({
        ...item,
        //  price: parseFloat((item.quantity * item.cost * item.course).toFixed(2)) || undefined,
        stocks: item.availability === 'В НАЛИЧИИ' ? 100 : item.availability === 'МАЛО' ? 10 : 0,
      }));
      return trueData;
    }
    // pirs
    if (providerId === 6) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          brand: item['Бренд'],
          barcode: item['Штрихкод'] || '',
          image: item['Картинка'],
          name: (item['Номенклатура'] || item['Наименование'] || '').trim(),
          //new_name: (item['Новое наименование'] || '').trim(),
          quantity: item['Кратность'] || 1,
          cost: item['Цена, $'],
          course: provider.course,
          stocks: item['Количество'],
        }))
        .filter((item) => item.sku !== '');

      trueData = trueData.map((item) => ({
        ...item,
        //price: parseFloat((item.quantity * item.cost * item.course).toFixed(2)),
      }));
      return trueData;
    }
    //kosmart
    if (providerId === 35) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          brand: item['Бренд'] || item['Производитель'],
          barcode: item['Штрихкод'] || '',
          min_opt: 1,
          name: (item['Номенклатура'] || item['Заголовок'] || '').trim(),
          quantity: 1,
          price: item['Цена оптовая'],
          stocks: item['Остаток'],
        }))
        .filter((item) => item.name !== '');
      return trueData;
    }
    //kdv
    if (providerId === 36) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          sku_1c: item['Артикул'] || '',
          barcode: item['Штрихкод'] || '',
          brand: item['Производитель'],
          category: item['Категория'],
          name:
            item['Склад / Номенклатура'] || item['Номенклатура']
              ? (item['Склад / Номенклатура'] || item['Номенклатура']).trim()
              : undefined,
          cost: item['Цена'],
          stocks: item['Доступно'],
          image: item['Изображение 1'],
          course: provider.course,
          min_opt: 1,
          quantity: item['Количество в упаковке'],
          // url: item['Ссылка на товар'],
          // new_name: item['Заголовок'],
          // description: item['Описание']
        }))
        .filter((item) => item.sku !== '' && item.name !== '');

      trueData = trueData
        .filter((item) => item.cost > 0)
        .map((item) => ({
          ...item,
          sku:
            item.sku[item.sku.length - 1] == 'A' || item.sku[item.sku.length - 1] == 'А'
              ? item.sku.toString().substr(0, item.sku.length - 1)
              : item.sku, // товар из акции заводим как обычный
          cost: item.sku[item.sku.length - 1] == 'A' || item.sku[item.sku.length - 1] == 'А' ? null : item.cost,
        }));

      return trueData;
    }
    //kristaller
    if (providerId === 38) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          brand: item['Бренд'],
          barcode: item['Штрихкод'] || '',
          description: item['Описание'],
          category: item['Категория'] || item['Подраздел'],
          name: item['Наименование элемента'] || item['Наименование'],
          new_name: item['Новое наименование'], // подливается с прайса выкаченого по апи
          quantity: 1,
          price: item['Цена'] || item['Цена ОПТ'], // поправить
          stocks: item['Остаток'] || item['Доступное количество'],
          image: item['Ссылка на фото'] || item['Детальная картинка (путь)'],
          url: item['Ссылка на товар'],
          min_opt: 1,
        }))
        .filter((item) => (item.name || item.new_name) && item.sku !== '' && parseInt(item.stocks) > 1);

      return trueData;
    }
    // gavrish
    if (providerId === 26) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'] || '',
          barcode: item['Штрихкод'] || '',
          brand: item['Бренд'],
          image: item['Изображение 1'],
          name: item['Наименование'] ? item['Наименование'].trim() : undefined,
          quantity: 1,
          cost: item['Цена, руб'],
          price: item['Цена, руб'],
          course: 1,
          min_opt: item['Мин. парт.'] || item['Минимальная партия'],
        }))
        .filter((item) => item.sku !== '' && item.name !== undefined);

      trueData = trueData.map((item) => ({
        ...item,
        stocks: 200,
      }));

      return trueData;
    }
    // 18+
    if (providerId === 40) {
      let trueData = data
        .map((item) => ({
          sku: item['aID'] || '',
          brand: item['vendor'],
          category: item['category3'],
          image: item['img1'],
          barcode: item['barcode'] || '',
          name: (item['productName'] || '').trim(),
          quantity: 1,
          min_opt: 1,
          course: 1,
          cost: item['wholePrice'],
          price: item['wholePrice'],
          stocks: item['stock'],

          //   description: item['description'], // передавать в парсере
          // model: item['category1'] === 'Бельё' ? item['prodID'] : null, // передавать в парсере
          // color: item['category1'] === 'Бельё' ? item['color'] : null, // передавать в парсере
          // size: item['category1'] === 'Бельё' ? item['size'] : null, // передавать в парсере
        }))
        .filter((item) => item.name !== '');
      return trueData;
    }
    //4fresh
    if (providerId === 41) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          brand: item['Бренд'],
          barcode: item['Штрихкод'] || '',
          description: item['Описание'],
          name: (item['Номенклатура'] || 'Заголовок' || '').trim(),
          new_name: item['Полное наименование'],
          quantity: 1,
          min_opt: 1,
          course: 1,
          cost: item['Цена'],
          price: item['Цена'],
          stocks: item['Доступно'],

          // category: item['Категория 1'], с парсера
          // image: item['Изображение 1'], c парсера
        }))
        .filter((item) => item.sku !== '');

      return trueData;
    }
    //русские традиции
    if (providerId === 7) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'] || '',
          barcode: item['Штрихкод'] || '',
          name: (
            item['Наименование'] ||
            item['Заголовок'] ||
            item['Заголовок'] ||
            item['Номенклатура, Характеристика'] ||
            ''
          ).trim(),
          new_name: item['Новое наименование'], // потом убрать
          quantity: 1,
          min_opt: 1,
          course: 1,
          cost: item['Цена'],
          price: item['Цена'],
          stocks: item['Остаток'] || item['Доступно'],
          //  brand: item['Производитель'], c  парсера
          // category: item['Категория'] || item['Категория 1'],c  парсера
          // image: item['Изображение 1'], c  парсера
        }))
        .filter((item) => item.sku !== '');

      return trueData;
    }
    //сладрус
    if (providerId === 29) {
      const MAP_STOCKS = {
        'В наличии': 30,
        'Осталось несколько штук': 5,
        'Осталось 2 штуки': 2,
        'Осталась 1 штука': 1,
        'Нет в наличии': 0,
        '': 0,
      };
      let trueData = data
        .map((item) => ({
          url: item['Ссылка на товар'], // сладрус мапим по url
          sku: item['артикул поставщика'], // сладрус мапим по url
          brand: item['Бренд'],
          category: item['Категория'],
          name: (item['Наименование'] || '').trim(),
          quantity: 1,
          min_opt: 1,
          course: 1,
          cost: item['Цена'],
          price: item['Цена'],
          stocks: MAP_STOCKS[(item['Остаток'] || '').trim()],
        }))
        .filter((item) => item.url !== '');

      return trueData;
    }
    // мир красок
    if (providerId === 39) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'],
          name: (item['Номенклатура'] || '').trim(),
          stocks: item['Доступно'],
          price: item['Цена'],
        }))
        .filter((item) => item.sku !== '' && item.name.length > 0);

      return trueData;
    }
    // Обезличка
    if (providerId === 8) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          name: (item['Наименование'] || '').trim(),
          stocks: item['Остаток'],
          price: item['Цена'],
          image: item['Ссылка на фото'],
          barcode: item['Штрихкод'],
        }))
        .filter((item) => item.sku !== '' && item.name.length > 0);

      return trueData;
    }

    // Ashanti
    if (providerId === 46) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          name: (item['Наименование'] || '').trim(),
          stocks: item['Остаток'],
          price: parseInt(item['Цена']) || undefined,
          cost: parseInt(item['Цена']) || undefined,
          barcode: item['Штрихкод'],
          brand: item['Бренд'],
          quantity: 1,
          min_opt: 1,
          course: 1,
        }))
        .filter((item) => item.sku !== '' && item.name.length > 0);

      return trueData;
    }

    // Snubway
    if (providerId === 44) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'],
          name: (item['Номенклатура'] || '').trim(),
          stocks: item['Доступно'],
          price: item['Цена'],
          barcode: item['Штрихкод'],
        }))
        .filter((item) => item.sku !== '' && item.name.length > 0);

      return trueData;
    }

    // Armtek
    if (providerId === 12) {
      let trueData = data
        .map((item) => ({
          sku: item['Код АРМТЕК'],
          sku_1c: item['Артикул 1c'],
          //name: (item['Номенклатура'] || '')?.trim() || "",
          stocks: MAP_STOCKS_AT[item['Количество']] || item['Количество'],
          price: item['Цена с точкой'],
          barcode: item['Штрихкод'],
          min_opt: item['Мин. парт.'] || item['Минимальная партия'],
          brand: item['Бренд'],
        }))
        .filter((item) => item.sku !== '');

      return trueData;
    }

    // Колобок
    if (providerId === 5) {
      let trueData = data
        .map((item) => ({
          sku: item['№'],
          name: (item['Наименование товаров'] || '').trim(),
          price: item['Цена'],
          stocks: item['Остаток'],
          barcode: item['Штрихкод'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '');

      return trueData;
    }

    // NovaSport
    if (providerId === 16) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          name: (item['Номенклатура'] || '').trim(),
          price: item['Цена'],
          barcode: item['Штрихкод'],
          stocks: item['Наличие'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '' && item.stocks > 0);

      return trueData;
    }

    // НашаИгрушка
    if (providerId === 17) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'],
          name: (item['Наименование'] || '').trim(),
          price: item['Отпускная Цена СО СКИДКОЙ'] || item['Цена'],
          barcode: item['Штрихкод'],
          stocks: item['На складе'],
          min_opt: item['Мин. отпуск'] || item['Кратность'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '' && item.stocks > 0);

      return trueData;
    }

    // Lumna
    if (providerId === 18) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'],
          name: (item['Наименование'] || '').trim(),
          price: item['Цена'],
          barcode: item['EAN'],
          stocks: item['Остаток'],
          // min_opt: item['Мин. отпуск'] || item['Кратность'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '' && item.stocks > 2);

      return trueData;
    }

    // Восток
    if (providerId === 21) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          name: (item['Наименование'] || '').trim(),
          price: item['Цена'],
          stocks: item['Остаток'],
          min_opt: item['Минпартия'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '');

      return trueData;
    }

    //Все инстурменты
    if (providerId === 20) {
      console.log(data);
      let trueData = data
        .map((item) => {
          const name = item['Наименование товара'] || item['Товар'] || '';
          return {
            sku: item['Код для заказа'],
            sku_1с: item['Ску'],
            name: typeof name === 'string' ? name?.trim() : null,
            price: item['Продажная цена МСК, руб'] || item['Опт 4'],
            category: item['Рубрика в каталоге'] || item['Рубрикатор ур 2'],
            barcode: item['Баркод'],
            stocks: MAP_STOCKS_VI[item['В наличии']] || item['В наличии'] || item['Остатки'],
          };
        })
        .filter((item) => (item.sku !== '' && item.name !== '') || !item.sku_1c);

      console.log(trueData);
      return trueData;
    }

    //NatureVector
    if (providerId === 23) {
      let trueData = data
        .map((item) => ({
          sku: item['артикул'],
          brand: item['производитель'],
          name: (item['Наименование'] || item['наименование'])?.trim(),
          price: item['цена II'],
          category: item['группа товаров'],
          barcode: item['штрихкод'],
          stocks:
            item['Остаток'] ||
            item['остаток\n/шт'] ||
            item['остаток\n /шт'] ||
            item['остаток'] ||
            item['Остаток\n /шт'] ||
            item['остаток\n  /шт'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '');

      console.log(trueData);

      return trueData;
    }

    //SweetOpt
    if (providerId === 22) {
      let trueData = data
        .map((item) => ({
          sku: item['Код'],
          name: (item['Наименование'] || '').trim(),
          price: item['Цена'],
          stocks: item['Наличие'],
          min_opt: item['Мин'],
          barcode: item['Штрихкод'],
          min_kor: item['В коробке'],
        }))
        .map((item) => {
          if (item.stocks === 'ЕСТЬ') {
            if (item.min_opt > 1) item.stocks = item.min_opt * 10;
            else item.stocks = Math.ceil(150 / item.price) * 10;
          } else if (item.stocks === 'МАЛО') {
            if (item.min_opt > 1) item.stocks = item.min_opt * 1;
            else item.stocks = Math.ceil(150 / item.price) * 2;
          }
          return item;
        })
        .filter((item) => item?.sku !== '' && item?.name !== '');

      return trueData;
    }

    //MarkerToys
    if (providerId === 34) {
      let trueData = data
        .map((item) => ({
          sku_1c: item['Артикул_1c'],
          sku: item['Артикул'] || item['Код'],
          name: (item['Наименование'] || item['Номенклатура'])?.trim(),
          brand: item['Бренд'] || item['Марка'],
          stocks: item['Остаток'],
          price: item['Цена'] || item['Цена опт'],
        }))
        .filter((item) => item.sku !== '' && item.name !== '');

      return trueData;
    }

    //Merlion
    if (providerId === 4) {
      let trueData = data
        .map((item) => ({
          sku: item['Номер'],
          name: item['Наименование']?.trim(),
          brand: item['Бренд'],
          category: item['Группа 3'],
          min_opt: item['Мин. партия покупки'],
          stocks: item['Доступно'],
          price: item['Цена(руб)'],
        }))
        .map((item) => {
          if (item.stocks?.includes('+')) {
            const countPlus = item.stocks.length;
            item.stocks = countPlus * 10;
          } else {
            item.stocks = 0;
          }
          return item;
        })
        .filter((item) => item.sku !== '' && item.name !== '');

      return trueData;
    }

    //Parker
    if (providerId === 42) {
      let trueData = data
        .map((item) => {
          return {
            sku: item['Артикул пр-ля'],
            brand: item['Бренд'],
            name: item['Наименование']?.trim(),
            price: item['предоплата'],
            stocks: item['Остаток'] || 0,
          };
        })
        .filter((item) => item.sku !== '' && item.name !== '');

      return trueData;
    }

    //opt24
    if (providerId === 19) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          name: (item['Наименование товара'] || '').trim(),
          price: item['Цена'],
          stocks: item['Остаток'],
          min_opt: item['Мин'],
          barcode: item['Штрихкод'],
          min_kor: item['МинОпт'],
        }))
        .map((item) => {
          if (item.stocks === 'ЕСТЬ') {
            if (item.min_opt > 1) item.stocks = item.min_opt * 10;
            else item.stocks = Math.ceil(150 / item.price) * 10;
          } else if (item.stocks === 'МАЛО' || item.stocks === 'ОЧЕНЬ МАЛО') {
            if (item.min_opt > 1) item.stocks = item.min_opt * 1;
            else item.stocks = Math.ceil(150 / item.price) * 2;
          }
          return item;
        })
        .filter((item) => item?.sku !== '' && item?.name !== '');

      return trueData;
    }

    //tngtoys
    if (providerId === 48) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          // name: (item['Номенклатура'] || '').trim(),
          price: item['Цена'],
          stocks: item['Остаток'],
          // min_opt: item['Мин'],
          // min_kor: item['МинОпт'],
        }))
        .filter((item) => item?.sku !== '' && item?.name !== '');

      return trueData;
    }

    //ammaPet
    if (providerId === 51) {
      let trueData = data
        .map((item) => ({
          sku: item['Артикул'],
          // name: (item['Номенклатура'] || '').trim(),
          price: item['Цена'],
          stocks: item['Доступное количество'],
          // min_opt: item['Мин'],
          // min_kor: item['МинОпт'],
        }))
        .filter((item) => item?.sku !== '' && item?.name !== '');

      return trueData;
    }

    //eksmo
    if (providerId === 52) {
      let trueData = data
        .map((item) => ({
          sku: item['Код товара'],
          name: (item['Название'] || '').trim(),
          price: item['Стоимость'] * 0.8,
          stocks: 5,
          // min_opt: item['Мин'],
          // min_kor: item['МинОпт'],
        }))
        .filter((item) => item?.sku !== '' && item?.name !== '');

      return trueData;
    }
    /* 
        if (providerId === 22) {
          const MAP_STOCKS = {
            'ЕСТЬ': 30,
            'МАЛО': 5,
            '': 0,
          };
          let trueData = data
            .map((item) => ({
              sku: item['Код'], 
              barcode: item['Штрихкод'],
              name: (item['Наименование'] || '').trim(),
              quantity: 1,
              course: 1,
              cost: item['Цена'],
              price: item['Цена'],
              stocks: MAP_STOCKS[(item['Наличие'] || '').trim()],
            }))
            .filter((item) => item.name !== '');
    
          return trueData;
        } */
  };

  const importData = async (file, skladName) => {
    const data = await formProviderDataStocks(selectProvider.id, file);

    console.log(data);
    const limit = 2000;

    const subarray = divideToSubarray(data, limit);

    if (subarray.length > 0) {
      for (let j = 0; j < subarray.length; j++) {
        await StocksApi.addStocks({ data: { providerId: selectProvider.id, products: subarray[j], skladName: skladName } })
          .then(() => console.log('load', j * limit, '-', (j + 1) * limit))
          .catch((err) => console.log(err));
      }
    }
  };

  const changeProviderCourse = async (course) => {
    await ProviderInfoApi.changeProvider({ data: { providerId: provider.id, data: { course: parseInt(course) } } })
      .then((r) =>
        dispatch(uiChangeProvider({ ...provider, course })),
      );
  };

  const loadProductsComplexBar = async () => {
    await ComplexBarApi.loadProducts({});
  };

  const loadProductsStocksETM = async () => {
    await EtmApi.updateStocks({});
  };

  const loadProductsPricesETM = async () => {
    await EtmApi.updatePrices();
  };

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => item.is_stock);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  useEffect(() => {
    if (selectProvider) {
      changeProvider(selectProvider);

      const provider_data = providers.find((item) => selectProvider.id === item.id);
      if (provider_data) {
        changeProvider(provider_data); // прогрузка времени обновления остатка
      }
    } else {
      const p = allProviders.filter((item) => item.is_stock);
      changeProvider(p[0] || {});
    }
  }, [selectProvider, providers]);

  const isAdmin = user.role === 'owner' || user.role === 'admin';

  return (
    <Content>
      <Row style={{ alignItems: 'flex-start' }}>
        <WhiteBlock title="Поставщик" title_bold={provider.name} style={{ minWidth: '500px' }}>
          <Row style={{ alignItems: 'flex-end', marginBottom: '10px', marginTop: '-10px' }}>
            <Select
              width={'200px'}
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              style={{ marginRight: '10px' }}
              onSelect={(v) => dispatch(uiChangeProvider(v))}
            />

            {isAdmin && provider.id === 6 && (
              <Input
                label="Курс"
                width={'120px'}
                readOnly={!provider.id}
                value={provider.course}
                onBlur={(v) => changeProviderCourse(v)}
                style={{ marginRight: '10px' }}
              />
            )}
            {provider.id === 47 && (
              <Button type={TYPE_BUTTONS.WHITE} onClick={loadProductsComplexBar}>
                Обновить остатки
              </Button>
            )}
            {provider.id === 43 && (
              <>
                <Button type={TYPE_BUTTONS.WHITE} onClick={loadProductsStocksETM} style={{ marginRight: '10px' }}>
                  Обновить остатки
                </Button>
                <Button type={TYPE_BUTTONS.WHITE} onClick={loadProductsPricesETM}>
                  Обновить цены
                </Button>
              </>
            )}

            {[38, 46, 21, 34].includes(provider.id) && (
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  ProviderCommonApi.loadExcelStocks({ data: { providerId: provider.id } })
                }
                style={{ marginLeft: '15px' }}
              >
                Скачать прайс
              </Button>
            )}
          </Row>
          <Row style={{ margin: '10px 0 15px' }}>
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                ProviderCommonApi.excelSertificateTmp({ data: {} })
              }
            >
              Шаблон сертификатов
            </Button>
            <SendButton
              // multiple={true}
              sendApi={ProviderCommonApi.saveSertificate}
              style={{ marginLeft: '10px' }}
            >
              Подгрузить сертификаты
            </SendButton>
          </Row>

          <>
            <Row>
              <ImportExcelButton onChange={(d) => importData(d, 'msk')} style={{ marginRight: '10px' }}>
                Подгрузить остатки Мск
              </ImportExcelButton>
              <ImportExcelButton onChange={(d) => importData(d, 'ekb')} style={{ marginRight: '10px' }}>
                Подгрузить остатки Екб
              </ImportExcelButton>

              <Button type={TYPE_BUTTONS.RED} onClick={() => ProviderCommonApi.nullStocks({ data: { providerId: selectProvider.id } })}>
                Обнулить стоки
              </Button>
            </Row>
            <ProviderUpdateStatusBlock providerId={provider.id} />
          </>
        </WhiteBlock>
        <ProviderDasboardContentWhiteBlock providerId={provider.id} isSmallProvider={true} isImage={true} />
      </Row >

      <ProviderProductsTable providerId={provider.id} isSmallProvider={true} isCityStocks={true} />
    </Content >
  );
}

export default StocksPage;
